export default "__VITE_ASSET__BHjDExR5__"